import { useEffect, useState } from "react";
import { useMixpanel } from "gatsby-plugin-mixpanel";

export const useMixpanelTracker = (
  formId,
  track,
  selectorPrefix = "",
  deps = []
) => {
  const [trigger, setTrigger] = useState(0);
  const mixpanel = useMixpanel();

  useEffect(() => {
    if (!document) return;

    const forms = document.querySelectorAll(
      (selectorPrefix ? selectorPrefix + " " : "") + "form._form_" + formId
    );

    const handler = e => {
      const formData = Object.fromEntries(new FormData(e.target));

      track(mixpanel, formData)
    };

    if (forms && forms.length) {
      forms.forEach(f => f.addEventListener("submit", handler));
    } else {
      setTimeout(() => setTrigger(t => t + 1), 500);
    }

    return () => {
      if (forms && forms.length) {
        forms.forEach(f => f.removeEventListener("submit", handler));
      }
    };
  }, [...deps, trigger]);
};
